import { IndeedGeneralException } from './IndeedGeneralException';

export class IndeedCandidateRecentlyDeclinedException extends IndeedGeneralException {
  constructor(message: string) {
    super(message);
  }
}
